import React, { useEffect, useState, useRef } from 'react';
import { SVG_FADE_OUT_DELAY, INTRO_COLORS } from '../constants';
import IntroSound from './IntroSound';

const Signature = ({ isSoundEnabled, color = INTRO_COLORS.FIRST.TEXT }) => {
  const [svgContent, setSvgContent] = useState('');
  const animationDuration = 3;
  const [opacity, setOpacity] = useState(1);
  const [shouldPlaySound, setShouldPlaySound] = useState(false);
  const svgRef = useRef(null);

  // Эффект для начальной загрузки SVG
  useEffect(() => {
    fetch('/TAG.svg')
      .then(response => response.text())
      .then(content => {
        // First replace the animation duration
        let modifiedContent = content.replace(/animation: brush1 5s/g, `animation: brush1 ${animationDuration}s`);
        setSvgContent(modifiedContent);
        setShouldPlaySound(true);

        setTimeout(() => {
          setOpacity(0);
        }, (animationDuration * 1000) + SVG_FADE_OUT_DELAY);
      })
      .catch(error => {
        console.error('Error loading SVG:', error);
      });
  }, []); // Загружаем SVG только один раз при монтировании

  // Эффект для обновления цвета
  useEffect(() => {
    if (svgRef.current && svgContent) {
      const paths = svgRef.current.querySelectorAll('path');
      paths.forEach(path => {
        if (path.getAttribute('fill') !== 'none') {
          path.setAttribute('fill', color);
        }
        if (path.getAttribute('stroke') !== 'none') {
          path.setAttribute('stroke', color);
        }
      });
    }
  }, [color, svgContent]); // Обновляем только цвет, когда он изменяется

  return (
    <>
      <IntroSound shouldPlay={shouldPlaySound} isEnabled={isSoundEnabled} />
      <div 
        ref={svgRef}
        style={{
          opacity,
          transition: 'opacity 1s ease-out'
        }}
        dangerouslySetInnerHTML={{ __html: svgContent }} 
      />
    </>
  );
};

export default Signature;